import React,{useState} from 'react'
import Cards from './Cards'
import './Flash.css'
import {Data} from '../Data'




function Flashcomponet() {
// 	const [data,setData]=useState(Data)
 
// 	const Products=data.map((item)=>{
// return <Cards datas={item}/>
// 	})
  return (
    <>
    <Cards/>
 
   
    </>
  )
}

export default Flashcomponet